import { FullValidationErrorFragment } from '@common/graphql/fragments';
import { gql } from '@common/hooks';

export const CreateWorksProfile = gql`
  mutation createWorksProfile($input: CreateWorksProfileInput!) {
    createWorksProfile(input: $input) {
      worksProfile {
        id
      }
      errors {
        ...FullValidationErrorFragment
      }
    }
  }
  ${FullValidationErrorFragment}
`;

export const UpdateWorksProfile = gql`
  mutation updateWorksProfile($id: ID!, $input: UpdateWorksProfileInput!) {
    updateWorksProfile(id: $id, input: $input) {
      worksProfile {
        id
      }
      errors {
        ...FullValidationErrorFragment
      }
    }
  }
  ${FullValidationErrorFragment}
`;
